import React from 'react';
import { Icon } from './Icon.js';
export const IconMusicNote = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M13.5 7L19 8V4L13 3V17V16.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M9 21C11.2091 21 13 19.2091 13 17C13 14.7909 11.2091 13 9 13C6.79086 13 5 14.7909 5 17C5 19.2091 6.79086 21 9 21Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconMusicNote.js.map